/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        17/01/2022 16:34
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import * as BurgerMenuEnum from '../enumerators/BurgerMenuEnum'

export default class BurgerMenuComponent {
    trigger = '[data-hc-trigger="menu"],[data-hc-menu]'
    triggerSubmenu = '[data-hc-trigger="submenu"]'
    menuEntry = '[data-hc-id="menu-entry"]'

    constructor() {
        $(this.trigger).on('click', (e) => {
            if ($('body').hasClass(BurgerMenuEnum.MENU_IS_OPEN_CLASS)) {
                this.closeMenu(e)
            } else {
                this.openMenu(e)
            }
        })
        $(this.triggerSubmenu).on('click', (e) => {
            if (
                $(e.currentTarget)
                    .parents(this.menuEntry)
                    .hasClass(BurgerMenuEnum.SUBMENU_IS_OPEN_CLASS)
            ) {
                this.closeSubmenu($(e.currentTarget).parents(this.menuEntry).get(0))
            } else {
                this.openSubmenu($(e.currentTarget).parents(this.menuEntry).get(0))
            }
        })
    }

    openMenu(e) {
        $(e.currentTarget).addClass(BurgerMenuEnum.CROSS_ACTIVE_CLASS)
        $('body').addClass(BurgerMenuEnum.MENU_IS_OPEN_CLASS)
        const openEvent = new Event('open.hc.menu')
        document.dispatchEvent(openEvent)
    }

    closeMenu(e) {
        $(e.currentTarget).removeClass(BurgerMenuEnum.CROSS_ACTIVE_CLASS)
        $('body').removeClass(BurgerMenuEnum.MENU_IS_OPEN_CLASS)
        $(this.menuEntry).removeClass(BurgerMenuEnum.SUBMENU_IS_OPEN_CLASS)
        const closeEvent = new Event('close.hc.menu')
        document.dispatchEvent(closeEvent)
    }

    openSubmenu(e) {
        $(e).addClass(BurgerMenuEnum.SUBMENU_IS_OPEN_CLASS)
    }

    closeSubmenu(e) {
        $(e).removeClass(BurgerMenuEnum.SUBMENU_IS_OPEN_CLASS)
    }
}
